export const Appinfo = {
  isSoft: () => window.navigator.userAgent.includes("Electron"),
  name: "每日甘肃",
  logo: `/icons/png/128x128.png`,
};

export const Status = {
  newsAudit: ['未审', '删除', '已审', '发布'],
  color: ['#9e9e9e', '#795548', '#42a5f5', '#26a69a']
}

